import './TableAlreadyConnected.css'
import React from "react";

export class TableAlreadyConnected extends React.Component {

    renderDataTable = (data) => {
        return (
            <table className='table table-striped'>
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Connected ?</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((c, i) => 
                        <tr key={c.customerID}>
                            <td>{c.company}</td>
                            <td><input id={"ConnectedCompaniesTable-" + i} className="table-checkbox" type="checkbox" checked={c.connectionStatus} onChange={this.props.changeHandler} /></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        const {height, width, data} = this.props;
        return (
            <div className="tableFixHead tableContainer" style={{height: height, width: width}}>
                {this.renderDataTable(data)}
            </div>
        );
    }
}

export default TableAlreadyConnected;